import { render, staticRenderFns } from "./input-textarea.vue?vue&type=template&id=6def6912&scoped=true&"
import script from "./input-textarea.vue?vue&type=script&lang=js&"
export * from "./input-textarea.vue?vue&type=script&lang=js&"
import style0 from "./input-textarea.vue?vue&type=style&index=0&id=6def6912&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6def6912",
  null
  
)

export default component.exports